module.exports = __webpack_public_path__ + "static/media/site.e4d48105.jpeg";